import { render, staticRenderFns } from "./newMatch.vue?vue&type=template&id=657360d2&scoped=true"
import script from "./newMatch.vue?vue&type=script&lang=js"
export * from "./newMatch.vue?vue&type=script&lang=js"
import style0 from "./newMatch.vue?vue&type=style&index=0&id=657360d2&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657360d2",
  null
  
)

export default component.exports